import React, {PropTypes} from 'react';
import {Link} from 'react-router-dom';
import LazyLoad, {forceCheck} from 'react-lazyload';

import {ajaxGet} from '../../../helpers/apiData.js';
import {imagesLoaded} from "../../../helpers/imagesLoadCheck.js";
import {API} from '../../../settings.js';
import {favCheck} from '../../../helpers/favCheck.js';

import ListItem from './ListItem';
import SmallCard from './SmallCard';
import FavBtn from './FavBtn';
import FilterBtn from '../../nav/FilterBtn';
import FilterMenu from '../../nav/FilterMenu';
import RestaurantError from '../../RestaurantError';
import Empty from './Empty';
import PreLoader from "../../PreLoader";
import MenuItem from '../MenuItem';

import 'url-search-params-polyfill';

class ItemList extends React.Component {
  static propTypes = {
    category: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    view_info: PropTypes.func,
    wine_slug: PropTypes.string,
    viewToggle: PropTypes.string,
    favsTotal: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.view = 'list';
    this.list = null;
    this.itemNumber = 0;
    this.activeFilters = {ingredients: [], wine_type: [], body: [], wine_regions: [], sweetness: [], diets: []};

    this.state = {
      toggle: 'inactive',
      data: {products: null, ingredients: [], diets: [], status: '', choosen_filters: [], filters: {}, template: '', subcategories:[]},
      clear_list: false,
      loading: 'loading',
      list_width: 0,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleFavs = this.handleFavs.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }


  componentDidMount() {
    // get url query params
    this.query = new URLSearchParams(this.props.location.search);
    for (let p of this.query) {
      if (p[1]) {
        this.activeFilters[p[0]] = p[1].split(',').map(function (item) {
          return parseInt(item, 10);
        });
      }
    }

    this.lang = this.props.match.params.lang;
    this.restaurant = this.props.match.params.restaurant;
    this.cat = this.props.category;
    this.getData();
    window.addEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    // if url changes then we need to re render data
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.getData();
    }

    if (prevState.data.products !== this.state.data.products) {
      this.itemNumber = this.state.data.products.length;
      if (this.state.data.template === 'wine') {
        this.view = 'wines';
      }
      this.updateDimensions();
      // Sending view info to Restaurant.js to feed the Top and Bottom bars
      this.props.view_info(
        this.state.data.category,
        this.view,
        true,
        'default'
      );
    }

    this.query = new URLSearchParams(this.props.location.search);
    forceCheck();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleLoading() {
    this.setState({
      loading: imagesLoaded(this.list),
    });
  }

  updateDimensions() {
    let sideNavWidth = document.getElementById('sideNav').offsetWidth;
    let filtersWidth = document.getElementById('filterMenu').offsetWidth;

    if (window.innerWidth > 1024) {
      if (this.state.data.filters && this.state.data.filters.length !== 0 && this.state.data.template !== 'wine') {
        this.setState({list_width: window.innerWidth - (sideNavWidth + filtersWidth)});
      }
      else {
        this.setState({list_width: window.innerWidth - sideNavWidth});
      }
    }
    else {
      this.setState({list_width: window.innerWidth});
    }
  }

  getData() {
    let listProps = this.props;
    let endpoint = '';
    this.cat = listProps.category;

    // if there's filters apply them to endpoint
    let query = '?';
    let filter_query = ['ingredients', 'diets', 'body', 'sweetness', 'wine_regions', 'wine_type'];
    for (let i = 0; i < filter_query.length; i++) {
      if (this.activeFilters[filter_query[i]]) {
        query += '&' + filter_query[i] + '=' + this.activeFilters[filter_query[i]];
      }
    }

    // category, filter and featured endpoints
    if (listProps.category) {
      endpoint = '/' + this.cat.split("-").pop() + '/' + query;

    }
    else if (listProps.filter) {
      endpoint = '/filter/' + listProps.filter.split("-").pop() + '/' + query;
    }
    else {
      endpoint = '/featured/';
      this.view = 'featured';
    }

    // API call
    ajaxGet(API + this.lang + '/api/' + this.restaurant + '/items' + endpoint, this);
  }

  // we need an arrow function here because 'this' were the one passed by the onclick child <Filter>, and we need 'this'
  // of this class
  handleClickFilter(id, type) {

    // check if clicked filter already exists in active filter
    const filterExistsIndex = this.activeFilters[type].indexOf(id);

    // if filter is active remove if not add it
    if (filterExistsIndex === -1) {
      this.activeFilters[type].push(id);
    }
    else {
      this.activeFilters[type].splice(filterExistsIndex, 1);
    }

    // update browser url
    this.updateBrowserUrl();
  }

  handleSelectFilter(id, type) {

    this.activeFilters[type] = [id];

    // update browser url
    this.updateBrowserUrl();
  }

  handleFavs(total) {
    this.props.favsTotal(total);
  }

  //HANDLING THE FILTER BTN TOGGLE
  handleClick() {
    if (this.state.toggle === 'inactive') {
      this.setState({toggle: 'active', overlay: 'active', navToggle: 'inactive'});
    } else {
      this.setState({toggle: 'inactive', overlay: 'inactive'});
    }
  }

  clearAllFilters() {
    for (let item in this.activeFilters) {
      this.activeFilters[item] = [];
    }
    this.updateBrowserUrl();
  }

  updateBrowserUrl() {
    let query = '?' + Object.keys(this.activeFilters).map(
      items => `${encodeURIComponent(items)}=${encodeURIComponent(this.activeFilters[items])}`).join('&');
    const path = this.props.location.pathname + query;
    this.props.history.push(path);

    // call getData with the new filters
    this.getData();
  }

  renderResults() {
    let width = {
      width: this.state.list_width
    };

    // CHECKING FOR ERRORS FROM THE API
    // API GAVE ME AN ERROR :(
    if (this.state.data.status === "error") {
      return (
        <RestaurantError restaurant={this.restaurant} lang={this.lang} wine_slug={this.props.wine_slug} view="api"/>
      );
    }

    // CHECK IF API RESPONSE HAS ARRIVED to avoid a flash of no product
    //CHECK IF THERE ARE ANY RESULTS IN THE RESPONSE
    let listProducts = this.state.data.products.map((item) => { // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING FURTHER BELOW
      if (this.props.viewToggle === "cards") {
        return (
          <LazyLoad key={item.slug + '-' + item.id} height={250}>
            <div className="list-item">
              <Link to={'/' + this.lang + '/' + this.restaurant + `/items/` + item.category
              + `/` + item.slug + '-' + item.id}>
                <ListItem name={item.title}
                          gallery={item.gallery[0]} description={item.description}
                          price={item.price} list="true" itemType={item.item_type}
                          region={item.wine_region}
                          type={item.wine_type} template={this.state.data.template}
                          unit={item.unit}
                />
              </Link>
              <FavBtn restaurant={this.restaurant} itemType={item.item_type} pk={item.id} onClick={this.handleFavs}/>
            </div>
          </LazyLoad>
        );
      }

      
      else if (this.props.viewToggle === "tiles") {
        return (
          <LazyLoad key={item.slug + '-' + item.id} height={250}>
            <div className="list-tile">
              <Link to={'/' + this.lang + '/' + this.restaurant + `/items/` + item.category
              + `/` + item.slug + '-' + item.id}>
                <ListItem name={item.title}
                          gallery={item.gallery[0]} description={item.description}
                          price={item.price} likes={item.like} list="true" itemType={item.item_type}
                          category={item.category} region={item.wine_region}
                          type={item.wine_type} template={this.state.data.template} pk={item.id}
                          favList={favCheck(item.id, item.item_type)} unit={item.unity}
                />
              </Link>
              <FavBtn restaurant={this.restaurant} itemType={item.item_type} pk={item.id} onClick={this.handleFavs}/>
            </div>
          </LazyLoad>
        );
      }
      return (
        <LazyLoad key={item.slug + '-' + item.id} height={50}>
          <div className="list-smallcard">
            <SmallCard name={item.title} photo={item.gallery_small[0]}
                       price={Number(item.price)} lang={this.lang} slug={item.slug} restaurant={this.restaurant}
                       pk={item.id} cat={item.category}/>
            <FavBtn itemType={item.item_type} pk={item.id} onClick={this.handleFavs}/>
          </div>
        </LazyLoad>

      );

    });

    let listSubcategories = this.state.data.subcategories && this.state.data.subcategories.map((item) => {
      return (
        <LazyLoad key={item.slug + '-' + item.id} height={250}>
        <div className="list-item">
        <MenuItem parent={item.parent}
                  restaurant={this.restaurant} lang={this.lang}
                  category={item.name} picture={item.photo}
                  name={item.name} slug={item.slug} pk={item.id}
                  template={item.template}/>
        </div>
      </LazyLoad>
      );
    });
    
    if (this.state.data.products.length > 0 || (this.state.data.subcategories && this.state.data.subcategories.length > 0)) {

      return (
        <div className={'item-list ' + this.state.loading + ' ' + this.state.toggle} style={width}
             ref={(el) => {
               this.list = el;
             }}>
          <button className="btn body-back-btn" onClick={this.props.history.goBack}/>
          
            
          
          <div className="list-wrapper" onLoad={this.handleLoading}>
            {listSubcategories}
            {listProducts}
          </div>
          <FilterBtn toggle={this.state.toggle} onClick={this.handleClick}/>
        </div>
      );
    }
    else { // NO RESULTS WERE FOUND, RENDER A MSG
      return (
        <div className={"item-list " + this.state.loading} style={width} onLoad={this.handleLoading} ref={(el) => {
          this.list = el;
        }}>
          <Empty/>
          <FilterBtn toggle={this.state.toggle} onClick={this.handleClick}/>
        </div>
      );
    }
  }

  hasFilters() {
    if (this.state.data.filters && Object.keys(this.state.data.filters).length !== 0 && this.state.data.template !== 'wine') {
      return 'with-filters';
    }
    return 'no-filters';
  }

  render() {
    // FOUND THE RESULTS RENDERING THE MAPPED ITEMS HERE


    return (
      <div className={'content-wrapper ' + (this.hasFilters())}>

        {/*wine regions and type view
        {this.state.data.template === 'wine' ? this.shouldRedirect() : null}*/}

        {/* showing the pre-loader until images are loaded */}
        <PreLoader loading={this.state.loading}/>

        {/* Once images are loaded and once the received api data, call the function that maps the products and renders them */}
        {this.state.data.products !== null ? this.renderResults() : null}

        <FilterMenu filters={this.state.data.filters}
                    activeFilters={this.activeFilters}
                    template={this.state.data.template}
                    toggle={this.state.toggle}
                    handleClickFilter={(id, type) => this.handleClickFilter(id, type)}
                    handleSelectFilter={(id, type) => this.handleSelectFilter(id, type)}
                    clearAllFilters={() => this.clearAllFilters()}
                    handleClick={this.handleClick}
                    itemNumber={this.itemNumber}
        />

      </div>
    );
  }
}

export default ItemList;




/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/ItemList.js
 **/